import * as types from '../actions';

const initialState = {  
    status:0,
    activity:'',
    errorData:'',  
    unavailability:[],  
    unavailabilityPerDate:[],
    unavailableCrews:[],
    unavailabilityData:{}
}

export default function(state = initialState, action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 
    switch(action.type) {

        case types.CREW_UNAVAILABILITY_SUCCESS:
            if(response.status===200){             
                return {
                    ...state, 
                    unavailability:(response.data.results === undefined ? response.data : response.data.results),
                    status: response.status,  
                    activity:types.CREW_UNAVAILABILITY_SUCCESS+timeVar,          
                };                
            }else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.CREW_UNAVAILABILITY_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }     
            
        case types.CREW_UNAVAILABILITY_PER_DATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    unavailabilityPerDate:response.data,
                    status: response.status,  
                    activity:types.CREW_UNAVAILABILITY_PER_DATE_SUCCESS+timeVar,                               
                };
            }
            else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.CREW_UNAVAILABILITY_PER_DATE_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }    
            
        case types.UNAVAILABLE_CREW_LIST_SUCCESS:
            if(response.status===200){             
                return {
                    ...state, 
                    unavailableCrews:(response.data.results === undefined ? response.data : response.data.results),
                    status: response.status,  
                    activity:types.UNAVAILABLE_CREW_LIST_SUCCESS+timeVar,          
                };                
            }else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.UNAVAILABLE_CREW_LIST_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }
        case types.SAVE_UNAVAILABILITY_SUCCESS:
            if(response.status===200){             
                return {
                    ...state, 
                    status: response.status,  
                    activity:types.SAVE_UNAVAILABILITY_SUCCESS+timeVar,      
                };                
            }else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.SAVE_UNAVAILABILITY_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }
        case types.UPDATE_UNAVAILABILITY_SUCCESS:
            if(response.status===200){             
                return {
                    ...state, 
                    status: response.status,  
                    activity:types.UPDATE_UNAVAILABILITY_SUCCESS+timeVar,          
                };                
            }else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.UPDATE_UNAVAILABILITY_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }
        case types.DELETE_UNAVAILABILITY_SUCCESS:
            if(response.status===200){             
                return {
                    ...state, 
                    status: response.status,  
                    activity:types.DELETE_UNAVAILABILITY_SUCCESS+timeVar,          
                };                
            }else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.DELETE_UNAVAILABILITY_ERROR+timeVar, 
                    errorData:response.data                              
                };
            } 
        case types.GET_UNAVAILABILITY_SUCCESS:
            if(response.status===200){             
                return {
                    ...state,
                    unavailabilityData:response.data, 
                    status: response.status,  
                    activity:types.GET_UNAVAILABILITY_SUCCESS+timeVar,          
                };                
            }else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.GET_UNAVAILABILITY_ERROR+timeVar, 
                    errorData:response.data                              
                };
            } 
                
        default:
            return state;

    }
}